export const REDIRECT_URL = 'https://app.craftstory.com/'
export const HOST_API = 'https://api.craftstory.com/api/'
export const VERSION_SCHEMA = '3.0.0'
export const DNS = 'https://5e6587501055ab2eda1cca04e7dcd470@o4509388687147008.ingest.de.sentry.io/4509388841287760'
